import { render, staticRenderFns } from "./SectionSubTitle.vue?vue&type=template&id=4e5f716d&scoped=true&"
import script from "./SectionSubTitle.vue?vue&type=script&lang=js&"
export * from "./SectionSubTitle.vue?vue&type=script&lang=js&"
import style0 from "./SectionSubTitle.vue?vue&type=style&index=0&id=4e5f716d&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e5f716d",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/owldesign/Sites/snowpeak/website/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4e5f716d')) {
      api.createRecord('4e5f716d', component.options)
    } else {
      api.reload('4e5f716d', component.options)
    }
    module.hot.accept("./SectionSubTitle.vue?vue&type=template&id=4e5f716d&scoped=true&", function () {
      api.rerender('4e5f716d', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "development/vue-components/SectionSubTitle.vue"
export default component.exports